import React from 'react';
interface CardProps extends React.HTMLAttributes<HTMLDivElement> {
  hover?: boolean;
}
export function Card({
  children,
  className = '',
  hover = false,
  ...props
}: CardProps) {
  return <div className={`
        bg-card rounded-xl border border-white/5 shadow-xl
        ${hover ? 'hover:translate-y-[-2px] hover:shadow-2xl hover:bg-card-hover transition-all duration-300 cursor-pointer' : ''}
        ${className}
      `} {...props} data-id="element-188">
      {children}
    </div>;
}